import { colors } from '@lmc/common/constants'

export const getProgressColor = (percentage: number | undefined): string => {
  if (!percentage) {
    return ''
  }
  if (percentage === 0) {
    return colors.grey
  }
  if (percentage <= 40) {
    return colors.red
  }
  if (percentage <= 70) {
    return colors.yellow
  }
  if (percentage < 100) {
    return colors.green
  }
  return colors.successgreen
}
